import React from "react";
import profilePhoto from "../Images/Atanu.jpg"

const Footer = () => {
  return (
    <footer id="footer" className="mt-auto">
    <div className="top-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 pt-3 pb-2 text-center profile">
            <img src={profilePhoto} alt="" />
          </div>
          <div className="col-md-5 pt-3 pb-2">
            <div className="contact">CONTACT</div>
            <div className="my-3">
            Department of Chemical and Biochemical Engineering  <br/>
            Indian Institute of Technology Patna <br/>
            Bihta, Patna-801106 (Bihar), India <br/>
            </div>
            <div className="contact-details my-2"> Office:  <span>114/VI (Block VI)</span> </div>
            <div className="contact-details my-2"> Lab:  <span>007/VI (Block VI)</span> </div>
            <div className="contact-details my-2"> Mail: <span> atanu.metya@iitp.ac.in </span> </div>
            <div className="contact-details my-2"> Phone: <span>  +91 6115 233 831 </span> </div>
          </div>
          <div className="col-md-3 pt-3 pb-2">
          <div className="contact">Quick Links</div>
          <div className="my-3">
          <i className="bi bi-caret-right-fill"></i>
            <a target={"_blank"} className="remove-underline color-white" href="https://www.iitp.ac.in/">&nbsp;IITP Home</a>
            <br />
            <i className="bi bi-caret-right-fill"></i>
            <a target={"_blank"} className="remove-underline color-white" href="https://www.iitp.ac.in/index.php/departments/engineering-technology/chemical-and-biochemical-engineering">&nbsp;Department of CBE</a>
            <br />
            <i className="bi bi-caret-right-fill"></i>
            <a target={"_blank"} className="remove-underline color-white" href="https://library.iitp.ac.in/">&nbsp;IITP Library</a>
            <br />
            <i className="bi bi-caret-right-fill"></i>
            <a target={"_blank"} className="remove-underline color-white" href="https://www.iitp.ac.in/hostel/reachIITP.html">&nbsp;Reach IITP</a>
            <br />
            <i className="bi bi-caret-right-fill"></i>
            <a target={"_blank"} className="remove-underline color-white" href="https://www.facebook.com/iitp.ac.in/">&nbsp;IITP Facebook</a>
            <br />
            <i className="bi bi-caret-right-fill"></i>
            <a target={"_blank"} className="remove-underline color-white" href="https://www.instagram.com/iit_patna/?hl=en">&nbsp;IITP Instagram</a>
            <br />
            <i className="bi bi-caret-right-fill"></i>
            <a target={"_blank"} className="remove-underline color-white" href="https://twitter.com/iitpatna">&nbsp;IITP Twitter</a>
            <br />
          </div>
          </div>
        </div>
      </div>
    </div>
    <div className="copyright justify-content-between d-flex py-2 px-2">
      <div></div>
    <div>
    © 2022 IIT Patna
    </div>
    <div> Designed By: <a target={"_blank"} href="https://www.linkedin.com/in/ayushi-jain-938b27190/">Ayushi Jain</a></div>
    </div>
  </footer>
  );
};

export default Footer;
